import { OwnAdministrativeFeeDetailDto } from './ownadministrativefeedetaildto';
import { pageDto } from './pagedto';

export class OwnAdministrativeFeeDetailResponse {

    listOwnAdministrativeFeeDetailDto: OwnAdministrativeFeeDetailDto[] = [];

    pageDto: pageDto = new pageDto({});
}